import { useMutation } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import client from '@/ports/api-client'
import { toast } from '@/components/toast-notifications'
import { deleteTrustScoreDraft } from '@/models/standalone-trust-score/apis'

const useDeleteTrustScoreDraft = () => {
  const { t } = useTranslation()

  const deleteTrustScoreDraftMutation = useMutation({
    mutationFn: ({ id }: { id: string }) => {
      const response = client.delete(`/trust_score/standalone/${id}`)
      return response
    },
    onSuccess: async () => {
      toast('', {
        title: `${t('l.standalone.view.delete.title', 'Trust Score deleted!')}`,
        type: 'success'
      })
    }
  })

  return deleteTrustScoreDraftMutation
}

export default useDeleteTrustScoreDraft
